import { type ToastProps, type SystemToastOptions } from './types'
import {
  showToastMessage,
  dismissToast,
} from '@wellesley/host-remote/api/actions'

export type SystemToastProps = {
  toast: Omit<ToastProps, 'id' | 'dismiss'>
  options?: SystemToastOptions
}

export const systemToast = ({ toast, options }: SystemToastProps) => {
  showToastMessage({ toast, options })
}

export const toast = {
  success: (title: string, options?: SystemToastOptions) =>
    systemToast({ toast: { type: 'success', title }, options }),
  error: (title: string, options?: SystemToastOptions) =>
    systemToast({ toast: { type: 'error', title }, options }),
  loading: (title: string, options?: SystemToastOptions) =>
    systemToast({ toast: { type: 'loading', title }, options }),
  dismiss: (toastId: string | number) => dismissToast(toastId),
}

export default toast
